export const updateCartCount = (count) => {
  let className = 'shacked';
  let $cart = $('#cart .badge');
  const current = $cart.text() - 0;

  if (!current) {
    $cart.removeClass('d-none');
  }

  $cart.text(current + count)
    .addClass(className);

  setTimeout(() => {
    $cart.removeClass(className);

    if (!(current + count)) {
      $cart.addClass('d-none');
    }

  }, 1000)
};

export const messages = window.translations;

export const initSlider = (sliderSelector = '') => {
  $(sliderSelector || '.carousel').each(function () {
    const total = $(this).find('.carousel-item').length;
    if (total) {
      $(this).find('.carousel-item').first().addClass('active');
    }

    if ( total > 1) {
      $('.btn-external-navi').removeClass('d-none');

      const isCart = ($(this).attr('id') === 'cartCarousel');
      const options = isCart
        ? {
          interval: false,
          wrap: false,
        }
        : {};

      $(this).carousel(options)
        .bcSwipe({threshold: 50})
        .on('slide.bs.carousel', function (event) {
          if (isCart) {
            $('.btn-action-prev').attr('disabled', function () {
              return (event.to === 0) ? 'disabled' : null
            });

            $('.btn-action-next').attr('disabled', function () {
              return (event.to === (total - 1)) ? 'disabled' : null
            });
          }
        })

    } else {
      $(this).find('.carousel-indicators, .carousel-control-prev, .carousel-control-next, .text-count').addClass('d-none');
      $('.btn-external-navi').addClass('d-none');
    }
  });
};

export const initFeatureSlider = () => {
  $('.home-slider').each(function() {
    const $el = $(this).find('.home-slider__list')[0];

    if ($el) {
      const $controls = $(this).find('.home-slider__control');
      const imgSize = 94 + 24 // img container  + margin;
      const {offsetWidth, scrollWidth} = $el;

      if (offsetWidth < scrollWidth) {
        $controls.removeClass('d-none')
          .bind('click', function (e) {
            e.preventDefault();
            const slide = $(this).data('slide');

            const scrollTo = slide === 'next'
              ? (($el.scrollLeft + offsetWidth >= scrollWidth) ? -$el.scrollLeft : imgSize)
              : (!$el.scrollLeft ? scrollWidth : -imgSize);

            // list
            $el.scrollBy({
              top: 0,
              left: scrollTo,
              behavior: 'smooth',
            });
          });
      } else {
        $controls.addClass('d-none')
      }
    }
  })
};

export const checkIsAutoFilled = ($container, data) => {
  if ($container.length && data.fields.length && data.target) {
    const $items = data.fields.map(item => ($container.find(`input[name="${item}"]`)));
    const $target = $container.find(`input[name="${data.target}"]`);
    const autofilled = {};

    const isAutoFilledTotal = () => {
      const length = Object.keys(autofilled).length;
      const truly = Object.keys(autofilled).map(item => (autofilled[item]-0)).reduce((a,b) => (a+b));

      return (truly/length) >= 0.5;
    };

    const runChecker = ($item) => {
      let valLength = $item.val().length;

      $item.bind('keyup', function() {
        const newValLength = $(this).val().length;
        autofilled[$item.attr('name')] = (newValLength - valLength) > 1;
        valLength = newValLength;
      })
    };

    const finalDetectionFlow = () => {
      const result = isAutoFilledTotal();

      $target.val(isAutoFilledTotal());

      if (result) {
        data.success && data.success();
      } else {
        data.fail && data.fail();
      }
    };

    $items.forEach($item => {
      autofilled[$item.attr('name')] = $target.val() === 'true';

      $item.bind('focus', function() {
        if (!$(this).val()) {
          runChecker($(this));
        } else {
          if (!autofilled[$(this).attr(name)]) {
            runChecker($(this));
          }
        }
      }).on('keyup', function(event) {
        const keyCode = (event.keyCode ? event.keyCode : event.which);

        // should be run after all previous checking
        setTimeout(() => {
          if (keyCode === '13' || !keyCode){
              finalDetectionFlow();
          }
        }, 1);

      })
      .bind('blur', () => {
        finalDetectionFlow();
      });
    })
  }
}

export const initAjaxFormValidation = () => {
  $('.ajax-validation').each(function() {
    const clear = ($el) => {
      const $target = $el || $(this).find('input, textarea');

      $target.removeClass('is-invalid')
        .next('small').addClass('d-none');
    }

    $(this).find('input, textarea').on('keyup', function() {
      clear($(this));
    });

    $('.ajax-validation')
      .on('ajax:beforeSend', () => {
        $(this).find('input, textarea').attr('disabled', 'disabled');
      })
      .on('ajax:complete', () => {
        $(this).find('input, textarea').removeAttr('disabled');
      })
      .on('ajax:success', () => {
        $(this).addClass('d-none')
          .next('.message').removeClass('d-none');
      })
      .on('ajax:error', (error) => {
        clear();
        window.logError(error, {location: 'ajax: error'});

        const errors = error.detail[0].errors;

        if (errors && Object.keys(errors).length) {
          Object.keys(errors).forEach((key) => {
            const $input = $(this).find('input, textarea').filter(`[name*="[${key}]"]`);

            if ($input.length) {
              $input.addClass('is-invalid')
                .next('small')
                .text(errors[key].join(', '))
                .removeClass('d-none');
            }
          })
        }
      })
  })
}

export const gtagTrack = (eventName, gtagData) => {
  if (window.gtag && gtagData) {
    gtag('event', eventName, {
      currency: gtagData.currency,
      items: gtagData.items,
      value: gtagData.value
    });
  }
}

export const copyToClipboard = (value) => {
  const elem = document.createElement('textarea');
  elem.value = value;
  document.body.appendChild(elem);
  elem.select();
  document.execCommand('copy');
  document.body.removeChild(elem);
}

export const overrideLinkTargets = ({$containerEl, hrefTestFn, targetValue}) => {
  const sameDomainRegex = new RegExp(`^${location.protocol}//${location.host}`);
  const links = $containerEl.getElementsByTagName('a');
  const hasAnyForm = !!document.querySelector('main form');

  [...links]
    .filter(link => {
      const href = link.getAttribute('href');
      return hrefTestFn ? hrefTestFn(href) : (hasAnyForm || !sameDomainRegex.test(href));
    })
    .forEach(link => {
      link.setAttribute('target', targetValue || '_blank');
    });
}
